<template>
    <div class="content">
        <section id="wrapper">
            <template v-if="section == 'faq'">
                <Faq />
            </template>
            <template v-else-if="section == 'tos'">
                <Tos />
            </template>
            <template v-else-if="section == 'privacy'">
                <Privacy />
            </template>
            <template v-else-if="section == 'coupon'">
                <Coupon />
            </template>
            <template v-else-if="section == 'download'">
                <Download/>
            </template>
            <template v-else-if="section == 'bridge'">
                <Bridge />
            </template>
            <template v-else-if="section == 'membership'">
                <Membership />
            </template>
            <template v-else-if="section == 'stampevent'">
                <StampEvent />
            </template>
        </section>

    </div>
</template>
<script>
    import Faq from '@/pages/help/Faq.vue'
    import Tos from '@/pages/help/Tos_202411.vue'
    import Privacy from '@/pages/help/Privacy_202411.vue'
    import Coupon from '@/pages/coupon/Coupon'
    import Download from '@/pages/download/Download.vue';
    import Membership from '@/pages/membership/Membership'
    import Bridge from '@/pages/download/Bridge.vue';
    import StampEvent from '@/pages/event/stamp/Stamp.vue'
    export default {
        name: 'pageforchina',
        components: { Faq, Tos, Privacy, Coupon , Download, Membership, Bridge, StampEvent },
        props: ['section', 'subpage'],
        computed: {
            servertime() {
                return this.$store.state.servertime
            }
        },
        created(){            
            if (this.section == 'intro') {
                // window.location.href = 'https://mp.weixin.qq.com/s/hiAw_UdBTE6VyScmgNfWZA'
                // 'https://mp.weixin.qq.com/s/w0D1auXnn9k74b9M2VkzNw'
                window.location.href = 'https://mp.weixin.qq.com/s/Y3BzinPuIO3PAn1LvZzkNg' 
                
            } else if (this.section == 'coupon') {
                // this.$store.commit('delIds')
            } else if (this.section == 'membership') {
                this.checkServerTimeAndRedirect()
            }
        },
        methods: {
            checkServerTimeAndRedirect() {
                if (!this.servertime) {
                    setTimeout(() => this.checkServerTimeAndRedirect(), 100)
                    return
                }

                const now = this.$moment(this.servertime)
                
                const promotionPeriod = {
                    start: '2025-02-20 01:00:00',
                    end: '2025-03-15 01:00:00'
                }
                
                const isInPromotionPeriod = now.isAfter(this.$moment(promotionPeriod.start)) && now.isBefore(this.$moment(promotionPeriod.end))
                const userType = this.$route.query.type
                const redirectUserTypes = ['new', 'membership']
                
                if (isInPromotionPeriod && redirectUserTypes.includes(userType) && process.env.NODE_ENV === 'production') {
                    this.$router.replace('/cn/membership')
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/PageForChina.vue